import { getStore } from '../util';
import { ValidationError } from '../util/error';

const getActions = async (from, to, includeCancel) => {
    const user = getStore('user');
    if (!user) {
        throw new ValidationError('token is not found');
      }
      let url = `/api/admin/actions?from=${from}&to=${to}`;
      if (includeCancel) {
        url += `&includeCancel=true`
      }
  const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
};

const getRate = async () => {
    const user = getStore('user');
    if (!user) {
        throw new ValidationError('token is not found');
      }
    let url = `/api/admin/turf`;
    const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        const data = await response.json();
        return data.rate
    }
    throw response;
};

const book = async(from, to, discount, tenant) => {
    const user = getStore('user');
    if (from && to && tenant) {
        let url = `/api/admin/book`;

        const response =  await fetch(url, {
            method: "POST",
            body: JSON.stringify({from: from, to: to, discount: discount, tenant: tenant}),
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': user.accessToken,
            }
        });
        if (response.ok) {
            return response.json();
        }
        throw response;
    }
}

const getAllBookings = async (from, to, includeCancel) => {
    const user = getStore('user');
    if (!user) {
        throw new ValidationError('token is not found');
      }
      let url = `/api/admin/bookings?from=${from}&to=${to}`;
      if (includeCancel) {
        url += `&includeCancel=true`
      }
  const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
};

export { getActions, getRate, book, getAllBookings }